<template>
  <div>
    <m-header
      :title-text="$t('casinos.integrationOptions')"
    />
    <l-rows>
      <l-rows>
        <l-rows-row content-position="right">
          <a-button
            :text="$t('casinos.createCasinoIntegrationOption')"
            variant="primary"
            @click="handleCreate"
          />
        </l-rows-row>
      </l-rows>
      <o-list
        :data="casinoIntegrationOptionPage.casinoIntegrationOptions"
        :columns="columns"
        :loading="casinoIntegrationOptionPageMeta.loading"
        :limit="casinoIntegrationOptionPageInput.limit"
        :offset="casinoIntegrationOptionPageInput.offset"
        :total="casinoIntegrationOptionPage.totalCount"
        selectable
        @select="handleSelect"
      />
    </l-rows>
  </div>
</template>

<script>
  import { AButton, LRows, LRowsRow, MHeader, OList } from 'codefabrik-gui-vue'
  import { useCasinoIntegrationOptionPage } from '@/views/casinos/casinoHooks'

  export default {
    name: 'CasinoIntegrationOptionList',
    components: { LRows, LRowsRow, MHeader, OList, AButton },
    computed: {
      columns () {
        return [
          {
            field: 'name',
            header: this.$t('common.name'),
            size: 4
          },
          {
            field: 'dataType',
            header: this.$t('common.dataType'),
            size: 2
          },
          {
            field: 'description',
            header: this.$t('common.description'),
          }
        ]
      }
    },
    methods: {
      handleCreate () {
        this.$router.push({ name: 'casino-integration-option-create' })
      },
      handleSelect (item) {
        this.$router.push({ name: 'casino-integration-option', params: { integrationOptionId: item.id } })
      }
    },
    mixins: [useCasinoIntegrationOptionPage()]
  }
</script>

<style scoped>

</style>
